/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/exclamation_medium'
export default icon
